import React, { useState, useEffect } from 'react';
import authentication from '../../B2CAuth';
import logComponent from '../../common/logComponent';

export default function UnauthenticatedTemplate({ children }) {
  const [signedIn, setSignedIn] = useState(null);

  if (logComponent('UnauthenticatedTemplate')) { console.debug('UnauthenticatedTemplate rendered'); }

    useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
      if (logComponent('UnauthenticatedTemplate')) {console.debug('UnauthenticatedTemplate onMount'); }
        const interval = setInterval(() => {
            setSignedIn(authentication.signedIn());
        }, 1000);
        return () => clearInterval(interval);
    }, []);


    if (!signedIn) {
        return (
            <div>
                {children}
            </div>
        );
    }
    return (null);
}
